import React from 'react';
import './successList.css';

const SuccessList = (props) => {
	const { heading, list } = props;
	if (Array.isArray(list) && list.length > 0) {
		return (
			<div className="success-list">
				{heading ? (<p className="success-list--message">{heading}</p>) : null}
				<ul className="success-list--list">
					{list.map((v) => {
						return (<li key={v.key}>{v.msg}</li>);
					})}
				</ul>
			</div>
		)
	} else {
		return null;
	}
};

export default SuccessList;

